/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.support.portal.rpc.AttachmentsRpc
 */
import * as References from './AttachmentsRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.support.portal.rpc.AttachmentsRpc#getUploadToken
 */
export const GET_UPLOAD_TOKEN_QUERY_FIELD_NAME = 'com_hubspot_support_portal_rpc_AttachmentsRpc_getUploadToken';
export const GET_UPLOAD_TOKEN_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_UPLOAD_TOKEN_QUERY_FIELD_NAME,
  args: ['params', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getUploadTokenRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.support.portal.rpc.AttachmentsRpc#getThreadAttachments
 */
export const GET_THREAD_ATTACHMENTS_QUERY_FIELD_NAME = 'com_hubspot_support_portal_rpc_AttachmentsRpc_getThreadAttachments';
export const GET_THREAD_ATTACHMENTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_THREAD_ATTACHMENTS_QUERY_FIELD_NAME,
  args: ['params', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getThreadAttachmentsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});